/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Start_AgainInputs */



/**
* | output |
* | --- |
* | "Practise again" |
*
* @param {Practice_Start_AgainInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_start_again = /** @type {((inputs?: Practice_Start_AgainInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Start_AgainInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opnieuw oefenen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'entraîner à nouveau")
	return /** @type {LocalizedString} */ ("Practise again")
});